export default "__VITE_ASSET__B$07M1q7__"